import { render, staticRenderFns } from "./CourseSchedule.vue?vue&type=template&id=5d67805e&scoped=true"
import script from "./CourseSchedule.vue?vue&type=script&lang=js"
export * from "./CourseSchedule.vue?vue&type=script&lang=js"
import style0 from "./CourseSchedule.vue?vue&type=style&index=0&id=5d67805e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d67805e",
  null
  
)

export default component.exports